import '/app/brewery-packages/content/content-editor-plugin-link/src/Link.css-raw';
export default {
  "link": "about-us-b998e096-link-d8xOKa"
};